var map = {
	"./custom/account.svg": [
		84272,
		4272
	],
	"./custom/adjust.svg": [
		48319,
		8319
	],
	"./custom/archive.svg": [
		30881,
		881
	],
	"./custom/article.svg": [
		75837,
		7203
	],
	"./custom/bell-notification.svg": [
		84218,
		4218
	],
	"./custom/brand-caregentic.svg": [
		86589,
		6589
	],
	"./custom/check-circle.svg": [
		69692,
		9692
	],
	"./custom/check.svg": [
		24911,
		4911
	],
	"./custom/chevron-up-down.svg": [
		44912,
		4912
	],
	"./custom/content.svg": [
		3565,
		3565
	],
	"./custom/copy.svg": [
		85601,
		5601
	],
	"./custom/dnd-gripper.svg": [
		62362,
		2362
	],
	"./custom/edit-2.svg": [
		85019,
		5019
	],
	"./custom/edit-3.svg": [
		59749,
		9749
	],
	"./custom/edit.svg": [
		59048,
		9048
	],
	"./custom/exclamation.svg": [
		87505,
		7505
	],
	"./custom/external-link.svg": [
		9294,
		9294
	],
	"./custom/eye.svg": [
		11110,
		1110
	],
	"./custom/filter-2.svg": [
		34658,
		4658
	],
	"./custom/filter.svg": [
		5916,
		5916
	],
	"./custom/grid.svg": [
		57561,
		7561
	],
	"./custom/heart.svg": [
		59497,
		5193
	],
	"./custom/i.svg": [
		84849,
		2424
	],
	"./custom/loader-2.svg": [
		91959,
		1959
	],
	"./custom/map.svg": [
		13087,
		3087
	],
	"./custom/medical.svg": [
		39075,
		9075
	],
	"./custom/message-circle-notification.svg": [
		51824,
		1824
	],
	"./custom/message-circle.svg": [
		95769,
		5769
	],
	"./custom/my-health.svg": [
		29455,
		9455
	],
	"./custom/navigation-2.svg": [
		44720,
		4720
	],
	"./custom/navigation.svg": [
		63665,
		3665
	],
	"./custom/plus.svg": [
		57438,
		7438
	],
	"./custom/program.svg": [
		9594,
		9594
	],
	"./custom/refresh-ccw.svg": [
		28272,
		8272
	],
	"./custom/refresh-cw.svg": [
		22426,
		46
	],
	"./custom/rx.svg": [
		84002,
		4002
	],
	"./custom/search.svg": [
		49734,
		9734
	],
	"./custom/sparkle-filled.svg": [
		5669,
		5669
	],
	"./custom/sparkle.svg": [
		1497,
		1497
	],
	"./custom/trash.svg": [
		88956,
		8956
	],
	"./custom/trending-down.svg": [
		5837,
		5837
	],
	"./custom/trending-up.svg": [
		24107,
		4107
	],
	"./custom/trending.svg": [
		1367,
		1367
	],
	"./custom/up-down.svg": [
		19480,
		9480
	],
	"./example/example.svg": [
		80319,
		319
	],
	"./feather/activity.svg": [
		37109,
		7109
	],
	"./feather/airplay.svg": [
		40809,
		809
	],
	"./feather/alert-circle.svg": [
		18135,
		8135
	],
	"./feather/alert-octagon.svg": [
		63915,
		3915
	],
	"./feather/alert-triangle.svg": [
		16632,
		6632
	],
	"./feather/align-center.svg": [
		45239,
		5239
	],
	"./feather/align-justify.svg": [
		32047,
		2047
	],
	"./feather/align-left.svg": [
		66035,
		6035
	],
	"./feather/align-right.svg": [
		46241,
		6241
	],
	"./feather/anchor.svg": [
		296,
		296
	],
	"./feather/aperture.svg": [
		83307,
		3307
	],
	"./feather/archive.svg": [
		57672,
		7672
	],
	"./feather/arrow-down-circle.svg": [
		61898,
		1898
	],
	"./feather/arrow-down-left.svg": [
		91302,
		1302
	],
	"./feather/arrow-down-right.svg": [
		59155,
		9155
	],
	"./feather/arrow-down.svg": [
		1918,
		1918
	],
	"./feather/arrow-left-circle.svg": [
		41733,
		1733
	],
	"./feather/arrow-left.svg": [
		29551,
		9551
	],
	"./feather/arrow-right-circle.svg": [
		71260,
		1260
	],
	"./feather/arrow-right.svg": [
		39311,
		9311
	],
	"./feather/arrow-up-circle.svg": [
		77474,
		7474
	],
	"./feather/arrow-up-left.svg": [
		93805,
		3805
	],
	"./feather/arrow-up-right.svg": [
		27481,
		7481
	],
	"./feather/arrow-up.svg": [
		31010,
		1010
	],
	"./feather/at-sign.svg": [
		75906,
		5906
	],
	"./feather/award.svg": [
		42738,
		2738
	],
	"./feather/bar-chart-2.svg": [
		76539,
		6539
	],
	"./feather/bar-chart.svg": [
		97137,
		7137
	],
	"./feather/battery-charging.svg": [
		5212,
		5212
	],
	"./feather/battery.svg": [
		69270,
		9270
	],
	"./feather/bell-off.svg": [
		80141,
		141
	],
	"./feather/bell.svg": [
		10952,
		952
	],
	"./feather/bluetooth.svg": [
		96874,
		6874
	],
	"./feather/bold.svg": [
		6275,
		6275
	],
	"./feather/book-open.svg": [
		89290,
		9290
	],
	"./feather/book.svg": [
		91356,
		1356
	],
	"./feather/bookmark.svg": [
		51857,
		1857
	],
	"./feather/box.svg": [
		97737,
		7737
	],
	"./feather/briefcase.svg": [
		61766,
		1766
	],
	"./feather/calendar.svg": [
		44541,
		4541
	],
	"./feather/camera-off.svg": [
		94934,
		4934
	],
	"./feather/camera.svg": [
		55622,
		5622
	],
	"./feather/cast.svg": [
		59019,
		9019
	],
	"./feather/check-circle.svg": [
		23725,
		3725
	],
	"./feather/check-square.svg": [
		52136,
		2136
	],
	"./feather/check.svg": [
		81620,
		1620
	],
	"./feather/chevron-down.svg": [
		27671,
		7671
	],
	"./feather/chevron-left.svg": [
		68688,
		8688
	],
	"./feather/chevron-right.svg": [
		24004,
		4004
	],
	"./feather/chevron-up.svg": [
		15809,
		5809
	],
	"./feather/chevrons-down.svg": [
		43651,
		3651
	],
	"./feather/chevrons-left.svg": [
		84259,
		8037
	],
	"./feather/chevrons-right.svg": [
		63500,
		3500
	],
	"./feather/chevrons-up.svg": [
		97512,
		7512
	],
	"./feather/chrome.svg": [
		96488,
		6488
	],
	"./feather/circle.svg": [
		67061,
		7061
	],
	"./feather/clipboard.svg": [
		88131,
		8131
	],
	"./feather/clock.svg": [
		26985,
		6985
	],
	"./feather/cloud-drizzle.svg": [
		49936,
		9936
	],
	"./feather/cloud-lightning.svg": [
		86287,
		6287
	],
	"./feather/cloud-off.svg": [
		95713,
		5713
	],
	"./feather/cloud-rain.svg": [
		77076,
		7076
	],
	"./feather/cloud-snow.svg": [
		76210,
		6210
	],
	"./feather/cloud.svg": [
		74403,
		4092
	],
	"./feather/code.svg": [
		40208,
		208
	],
	"./feather/codepen.svg": [
		73691,
		3691
	],
	"./feather/codesandbox.svg": [
		58283,
		8283
	],
	"./feather/coffee.svg": [
		91010,
		4170
	],
	"./feather/columns.svg": [
		9438,
		9438
	],
	"./feather/command.svg": [
		93710,
		3710
	],
	"./feather/compass.svg": [
		23518,
		3518
	],
	"./feather/copy.svg": [
		29786,
		9786
	],
	"./feather/corner-down-left.svg": [
		36531,
		6531
	],
	"./feather/corner-down-right.svg": [
		62498,
		2498
	],
	"./feather/corner-left-down.svg": [
		61352,
		1352
	],
	"./feather/corner-left-up.svg": [
		38173,
		8173
	],
	"./feather/corner-right-down.svg": [
		40274,
		274
	],
	"./feather/corner-right-up.svg": [
		49690,
		9690
	],
	"./feather/corner-up-left.svg": [
		96998,
		6998
	],
	"./feather/corner-up-right.svg": [
		29475,
		9475
	],
	"./feather/cpu.svg": [
		42304,
		2304
	],
	"./feather/credit-card.svg": [
		40766,
		766
	],
	"./feather/crop.svg": [
		5634,
		5634
	],
	"./feather/crosshair.svg": [
		90171,
		171
	],
	"./feather/database.svg": [
		16282,
		6282
	],
	"./feather/delete.svg": [
		70059,
		59
	],
	"./feather/disc.svg": [
		47056,
		7056
	],
	"./feather/divide-circle.svg": [
		1563,
		1563
	],
	"./feather/divide-square.svg": [
		99142,
		7715
	],
	"./feather/divide.svg": [
		80929,
		929
	],
	"./feather/dollar-sign.svg": [
		54446,
		4446
	],
	"./feather/download-cloud.svg": [
		73338,
		3338
	],
	"./feather/download.svg": [
		61031,
		1031
	],
	"./feather/dribbble.svg": [
		49673,
		9673
	],
	"./feather/droplet.svg": [
		73935,
		3935
	],
	"./feather/edit-2.svg": [
		60474,
		474
	],
	"./feather/edit-3.svg": [
		34998,
		4998
	],
	"./feather/edit.svg": [
		2323,
		2323
	],
	"./feather/external-link.svg": [
		12341,
		2341
	],
	"./feather/eye-off.svg": [
		81410,
		1410
	],
	"./feather/eye.svg": [
		77676,
		7676
	],
	"./feather/facebook.svg": [
		29974,
		9974
	],
	"./feather/fast-forward.svg": [
		65704,
		5704
	],
	"./feather/feather.svg": [
		55664,
		5664
	],
	"./feather/figma.svg": [
		97379,
		7379
	],
	"./feather/file-minus.svg": [
		43714,
		3714
	],
	"./feather/file-plus.svg": [
		14483,
		4483
	],
	"./feather/file-text.svg": [
		73036,
		3036
	],
	"./feather/file.svg": [
		7395,
		7395
	],
	"./feather/film.svg": [
		76420,
		6420
	],
	"./feather/filter.svg": [
		39710,
		9710
	],
	"./feather/flag.svg": [
		60659,
		659
	],
	"./feather/folder-minus.svg": [
		42607,
		2607
	],
	"./feather/folder-plus.svg": [
		2818,
		2818
	],
	"./feather/folder.svg": [
		55008,
		5008
	],
	"./feather/framer.svg": [
		17002,
		7002
	],
	"./feather/frown.svg": [
		84880,
		4880
	],
	"./feather/gift.svg": [
		6491,
		6491
	],
	"./feather/git-branch.svg": [
		71365,
		1365
	],
	"./feather/git-commit.svg": [
		61629,
		1629
	],
	"./feather/git-merge.svg": [
		61798,
		1798
	],
	"./feather/git-pull-request.svg": [
		48289,
		8289
	],
	"./feather/github.svg": [
		69660,
		9660
	],
	"./feather/gitlab.svg": [
		10494,
		494
	],
	"./feather/globe.svg": [
		1843,
		1843
	],
	"./feather/grid.svg": [
		87293,
		8808
	],
	"./feather/hard-drive.svg": [
		75078,
		5078
	],
	"./feather/hash.svg": [
		10290,
		290
	],
	"./feather/headphones.svg": [
		41998,
		1998
	],
	"./feather/heart.svg": [
		12785,
		2785
	],
	"./feather/help-circle.svg": [
		26765,
		6765
	],
	"./feather/hexagon.svg": [
		76746,
		6746
	],
	"./feather/home.svg": [
		69203,
		9203
	],
	"./feather/image.svg": [
		9304,
		9304
	],
	"./feather/inbox.svg": [
		70014,
		14
	],
	"./feather/info.svg": [
		20398,
		398
	],
	"./feather/instagram.svg": [
		55347,
		5347
	],
	"./feather/italic.svg": [
		46262,
		6262
	],
	"./feather/key.svg": [
		64089,
		4089
	],
	"./feather/layers.svg": [
		46096,
		6096
	],
	"./feather/layout.svg": [
		2528,
		2528
	],
	"./feather/life-buoy.svg": [
		71123,
		1123
	],
	"./feather/link-2.svg": [
		66838,
		6838
	],
	"./feather/link.svg": [
		19137,
		9137
	],
	"./feather/linkedin.svg": [
		43484,
		3484
	],
	"./feather/list.svg": [
		24586,
		4586
	],
	"./feather/loader.svg": [
		70616,
		616
	],
	"./feather/lock.svg": [
		87902,
		7902
	],
	"./feather/log-in.svg": [
		29543,
		9543
	],
	"./feather/log-out.svg": [
		83025,
		3025
	],
	"./feather/mail.svg": [
		80913,
		913
	],
	"./feather/map-pin.svg": [
		80739,
		739
	],
	"./feather/map.svg": [
		77758,
		7758
	],
	"./feather/maximize-2.svg": [
		16748,
		6748
	],
	"./feather/maximize.svg": [
		1658,
		1658
	],
	"./feather/meh.svg": [
		37105,
		7105
	],
	"./feather/menu.svg": [
		32909,
		2909
	],
	"./feather/message-circle.svg": [
		13853,
		3853
	],
	"./feather/message-square.svg": [
		93779,
		3779
	],
	"./feather/mic-off.svg": [
		89218,
		9218
	],
	"./feather/mic.svg": [
		39448,
		9448
	],
	"./feather/minimize-2.svg": [
		54391,
		4391
	],
	"./feather/minimize.svg": [
		17363,
		7363
	],
	"./feather/minus-circle.svg": [
		79878,
		9878
	],
	"./feather/minus-square.svg": [
		49010,
		9010
	],
	"./feather/minus.svg": [
		61229,
		1229
	],
	"./feather/monitor.svg": [
		44011,
		4011
	],
	"./feather/moon.svg": [
		9421,
		9421
	],
	"./feather/more-horizontal.svg": [
		6169,
		6169
	],
	"./feather/more-vertical.svg": [
		81060,
		1060
	],
	"./feather/mouse-pointer.svg": [
		67345,
		7345
	],
	"./feather/move.svg": [
		5505,
		5505
	],
	"./feather/music.svg": [
		9723,
		9723
	],
	"./feather/navigation-2.svg": [
		82332,
		2332
	],
	"./feather/navigation.svg": [
		84338,
		4338
	],
	"./feather/octagon.svg": [
		20864,
		864
	],
	"./feather/package.svg": [
		76041,
		6041
	],
	"./feather/paperclip.svg": [
		1663,
		1663
	],
	"./feather/pause-circle.svg": [
		14957,
		4957
	],
	"./feather/pause.svg": [
		21960,
		56
	],
	"./feather/pen-tool.svg": [
		54403,
		4403
	],
	"./feather/percent.svg": [
		49410,
		9410
	],
	"./feather/phone-call.svg": [
		89065,
		9065
	],
	"./feather/phone-forwarded.svg": [
		99643,
		9643
	],
	"./feather/phone-incoming.svg": [
		71484,
		1484
	],
	"./feather/phone-missed.svg": [
		93247,
		3247
	],
	"./feather/phone-off.svg": [
		67538,
		7538
	],
	"./feather/phone-outgoing.svg": [
		79404,
		9404
	],
	"./feather/phone.svg": [
		62798,
		2798
	],
	"./feather/pie-chart.svg": [
		18851,
		7206
	],
	"./feather/play-circle.svg": [
		55984,
		5984
	],
	"./feather/play.svg": [
		16367,
		6367
	],
	"./feather/plus-circle.svg": [
		77938,
		6021
	],
	"./feather/plus-square.svg": [
		86013,
		6013
	],
	"./feather/plus.svg": [
		71223,
		1223
	],
	"./feather/pocket.svg": [
		17385,
		7385
	],
	"./feather/power.svg": [
		27293,
		7293
	],
	"./feather/printer.svg": [
		10268,
		268
	],
	"./feather/radio.svg": [
		69014,
		9014
	],
	"./feather/refresh-ccw.svg": [
		26847,
		6847
	],
	"./feather/refresh-cw.svg": [
		30222,
		222
	],
	"./feather/repeat.svg": [
		37908,
		7908
	],
	"./feather/rewind.svg": [
		82389,
		2389
	],
	"./feather/rotate-ccw.svg": [
		38489,
		8489
	],
	"./feather/rotate-cw.svg": [
		18294,
		8294
	],
	"./feather/rss.svg": [
		87999,
		7999
	],
	"./feather/save.svg": [
		9494,
		9494
	],
	"./feather/scissors.svg": [
		6444,
		6444
	],
	"./feather/search.svg": [
		99889,
		9889
	],
	"./feather/send.svg": [
		15827,
		5827
	],
	"./feather/server.svg": [
		94992,
		4992
	],
	"./feather/settings.svg": [
		65632,
		5632
	],
	"./feather/share-2.svg": [
		83780,
		3780
	],
	"./feather/share.svg": [
		79317,
		9317
	],
	"./feather/shield-off.svg": [
		59637,
		9637
	],
	"./feather/shield.svg": [
		81505,
		1505
	],
	"./feather/shopping-bag.svg": [
		15028,
		5028
	],
	"./feather/shopping-cart.svg": [
		31518,
		1518
	],
	"./feather/shuffle.svg": [
		96798,
		6798
	],
	"./feather/sidebar.svg": [
		98704,
		8704
	],
	"./feather/skip-back.svg": [
		94944,
		4944
	],
	"./feather/skip-forward.svg": [
		85311,
		5311
	],
	"./feather/slack.svg": [
		7651,
		7651
	],
	"./feather/slash.svg": [
		79605,
		9605
	],
	"./feather/sliders.svg": [
		82298,
		2298
	],
	"./feather/smartphone.svg": [
		66162,
		6162
	],
	"./feather/smile.svg": [
		86760,
		6760
	],
	"./feather/speaker.svg": [
		66662,
		6662
	],
	"./feather/square.svg": [
		11313,
		1313
	],
	"./feather/star.svg": [
		63536,
		3536
	],
	"./feather/stop-circle.svg": [
		33635,
		3635
	],
	"./feather/sun.svg": [
		17557,
		7557
	],
	"./feather/sunrise.svg": [
		33413,
		3413
	],
	"./feather/sunset.svg": [
		80412,
		412
	],
	"./feather/table.svg": [
		65698,
		5698
	],
	"./feather/tablet.svg": [
		71868,
		1868
	],
	"./feather/tag.svg": [
		48091,
		8091
	],
	"./feather/target.svg": [
		71736,
		1736
	],
	"./feather/terminal.svg": [
		24362,
		4362
	],
	"./feather/thermometer.svg": [
		13882,
		3882
	],
	"./feather/thumbs-down.svg": [
		46681,
		6681
	],
	"./feather/thumbs-up.svg": [
		45585,
		5585
	],
	"./feather/toggle-left.svg": [
		19486,
		9486
	],
	"./feather/toggle-right.svg": [
		4262,
		4262
	],
	"./feather/tool.svg": [
		25944,
		5944
	],
	"./feather/trash-2.svg": [
		58746,
		8746
	],
	"./feather/trash.svg": [
		43998,
		3998
	],
	"./feather/trello.svg": [
		19989,
		9989
	],
	"./feather/trending-down.svg": [
		25146,
		5146
	],
	"./feather/trending-up.svg": [
		69184,
		9184
	],
	"./feather/triangle.svg": [
		39124,
		9124
	],
	"./feather/truck.svg": [
		21402,
		1402
	],
	"./feather/tv.svg": [
		28579,
		8579
	],
	"./feather/twitch.svg": [
		57332,
		7332
	],
	"./feather/twitter.svg": [
		9960,
		9960
	],
	"./feather/type.svg": [
		33828,
		3828
	],
	"./feather/umbrella.svg": [
		73447,
		3447
	],
	"./feather/underline.svg": [
		44641,
		4641
	],
	"./feather/unlock.svg": [
		11053,
		1053
	],
	"./feather/upload-cloud.svg": [
		99160,
		9160
	],
	"./feather/upload.svg": [
		54396,
		4396
	],
	"./feather/user-check.svg": [
		1152,
		1152
	],
	"./feather/user-minus.svg": [
		40831,
		831
	],
	"./feather/user-plus.svg": [
		73704,
		3704
	],
	"./feather/user-x.svg": [
		49226,
		9226
	],
	"./feather/user.svg": [
		77598,
		7598
	],
	"./feather/users.svg": [
		50835,
		835
	],
	"./feather/video-off.svg": [
		85433,
		5433
	],
	"./feather/video.svg": [
		63212,
		3212
	],
	"./feather/voicemail.svg": [
		58354,
		8354
	],
	"./feather/volume-1.svg": [
		95999,
		5999
	],
	"./feather/volume-2.svg": [
		31604,
		1604
	],
	"./feather/volume-x.svg": [
		8183,
		8183
	],
	"./feather/volume.svg": [
		98587,
		8587
	],
	"./feather/watch.svg": [
		86466,
		6466
	],
	"./feather/wifi-off.svg": [
		32616,
		2616
	],
	"./feather/wifi.svg": [
		38846,
		8846
	],
	"./feather/wind.svg": [
		5415,
		5415
	],
	"./feather/x-circle.svg": [
		2268,
		2268
	],
	"./feather/x-octagon.svg": [
		61464,
		1464
	],
	"./feather/x-square.svg": [
		56191,
		6191
	],
	"./feather/x.svg": [
		58053,
		8053
	],
	"./feather/youtube.svg": [
		61619,
		1619
	],
	"./feather/zap-off.svg": [
		83997,
		3997
	],
	"./feather/zap.svg": [
		82639,
		2639
	],
	"./feather/zoom-in.svg": [
		21392,
		1392
	],
	"./feather/zoom-out.svg": [
		4649,
		4649
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 19823;
module.exports = webpackAsyncContext;